<script setup>
/**
 * RED-310 — toolbar entry point of the Analüütika drawer. Rendered by
 * Transactions.vue only when the user holds `transactions-analytics` AND the
 * feature flag is on (the page gates it; this component never hides itself).
 *
 * Icon-only like its siblings (settings, layers): the subheader is capped at
 * max-w-2xl, so a visible label wraps the search row's Otsi button even at
 * 1920 px. The tooltip and aria-label carry the name.
 */
import { useAnalyticsStore } from '@/stores/analyticsStore'

const store = useAnalyticsStore()
</script>

<template>
  <Button
    icon="pi pi-chart-bar"
    class="shadow-md"
    data-testid="txn-analytics-open"
    :aria-label="$t('messages.transactions.analytics.button')"
    v-tooltip.bottom="$t('messages.transactions.analytics.tooltip')"
    @click="store.open()"
  />
</template>
